module.exports = __webpack_public_path__ + "img/swper2.a232eb78.png";